import { IconPropsType } from '..';

export const ListIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.54959 11.1998H12.5999V9.10043H4.54959V11.1998ZM4.54959 8.05012H12.5999V5.94949H4.54959V8.05012ZM4.54959 4.90043H12.5999V2.7998H4.54959V4.90043ZM1.3999 4.90043H3.50052V2.7998H1.3999V4.90043ZM1.3999 11.1998H3.50052V9.10043H1.3999V11.1998ZM1.3999 8.05012H3.50052V5.94949H1.3999V8.05012Z"
      fill="currentColor"
    />
  </svg>
);
